"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/input/semantics/textfield-label");
require("@/components/common/input/semantics/textfield-description");
require("@/components/common/input/semantics/textfield-validation");
/**
 * mm-form-field
 * textfield 계열이 아닌 컨트롤(gender-selector, checkbox-group, select 등)에
 * 레이블·설명·검증 텍스트를 textfield와 같은 규칙으로 붙이는 래퍼.
 * 컨트롤 자체는 slot으로 받고, 필드는 레이블이 붙은 그룹으로서 role="group"을 가진다.
 * label은 그룹의 이름이라 필수이며, 그룹이 화면의 레이블을 aria-labelledby로 가리킨다.
 * host 속성은 자기 shadow 안의 id를 가리킬 수 없으므로 그룹은 host가 아니라 shadow 안의 요소가 맡는다.
 *
 * mm-textfield와 병합하지 않는 이유: textfield는 자기 mm-input에 for·aria-describedby·
 * aria-invalid를 id로 배선하지만, form-field의 컨트롤은 slot 너머의 불투명한 요소라 그 배선을
 * 할 수 없다. 공통 규칙은 이미 mm-textfield-label/-description/-validation 서브컴포넌트 레벨에서
 * 공유하므로, 둘은 base/파생이 아니라 형제로 둔다.
 */
let FormField = class FormField extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.description = '';
        this.validationText = '';
        this.optional = false;
    }
    render() {
        return (0, lit_1.html) `
      <div class="group" role="group" aria-labelledby="label">
        <mm-textfield-label id="label" ?optional=${this.optional}>${this.label}</mm-textfield-label>
        <slot></slot>
        ${this.renderDescription()} ${this.renderValidation()}
      </div>
    `;
    }
    renderDescription() {
        if (!this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-textfield-description>${this.description}</mm-textfield-description>
    `;
    }
    renderValidation() {
        if (!this.validationText)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-textfield-validation>${this.validationText}</mm-textfield-validation>
    `;
    }
};
FormField.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    .group {
      display: flex;
      flex-direction: column;
      gap: var(--space-1);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FormField.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FormField.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'validation-text' })
], FormField.prototype, "validationText", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], FormField.prototype, "optional", void 0);
FormField = __decorate([
    (0, decorators_js_1.customElement)('mm-form-field')
], FormField);
exports.FormField = FormField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1maWVsZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZvcm0tZmllbGQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQW9EO0FBQ3BELHFEQUEyRDtBQUUzRCwrREFBNEQ7QUFDNUQscUVBQWtFO0FBQ2xFLG9FQUFpRTtBQUVqRTs7Ozs7Ozs7Ozs7O0dBWUc7QUFFSSxJQUFNLFNBQVMsR0FBZixNQUFNLFNBQVUsU0FBUSxnQkFBVTtJQUFsQzs7UUFZdUIsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQUNWLGdCQUFXLEdBQUcsRUFBRSxDQUFBO1FBQ2MsbUJBQWMsR0FBRyxFQUFFLENBQUE7UUFDaEQsYUFBUSxHQUFHLEtBQUssQ0FBQTtJQTJCL0MsQ0FBQztJQXpCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7bURBRW9DLElBQUksQ0FBQyxRQUFRLElBQUksSUFBSSxDQUFDLEtBQUs7O1VBRXBFLElBQUksQ0FBQyxpQkFBaUIsRUFBRSxJQUFJLElBQUksQ0FBQyxnQkFBZ0IsRUFBRTs7S0FFeEQsQ0FBQTtJQUNILENBQUM7SUFFTyxpQkFBaUI7UUFDdkIsSUFBSSxDQUFDLElBQUksQ0FBQyxXQUFXO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFckMsT0FBTyxJQUFBLFVBQUksRUFBQTtrQ0FDbUIsSUFBSSxDQUFDLFdBQVc7S0FDN0MsQ0FBQTtJQUNILENBQUM7SUFFTyxnQkFBZ0I7UUFDdEIsSUFBSSxDQUFDLElBQUksQ0FBQyxjQUFjO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFeEMsT0FBTyxJQUFBLFVBQUksRUFBQTtpQ0FDa0IsSUFBSSxDQUFDLGNBQWM7S0FDL0MsQ0FBQTtJQUNILENBQUM7O0FBeENNLGdCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7R0FVbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7d0NBQVc7QUFDVjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7OENBQWlCO0FBQ2M7SUFBekQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsaUJBQWlCLEVBQUUsQ0FBQztpREFBb0I7QUFDaEQ7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDOzJDQUFpQjtBQWZsQyxTQUFTO0lBRHJCLElBQUEsNkJBQWEsRUFBQyxlQUFlLENBQUM7R0FDbEIsU0FBUyxDQTBDckI7QUExQ1ksOEJBQVMifQ==